import styled from 'styled-components';
import { Box, Typography, TextField } from '@mui/material';
import { makeStyles } from '@mui/styles';

// The white card on the admin dashboard. Only AdminPanel.tsx uses this file's
// SBox — components/Intro has its own copy — so widening it here is contained.
//
// 620px, not the 950px the applications page uses: this holds a 2x2 grid of
// `aspect-ratio: 1/1` tiles, so the card's width sets their height directly.
// At 950px each tile came out ~440px tall.
export const SBox = styled(Box)`
  background-color: #FFFFFF;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 620px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: auto;
  box-sizing: border-box;
  @media (max-width: 768px) {
    max-width: 100%;
    padding: 16px;
  }
`;


export const SLabelTop = styled.label`
  color: #60646E;
  font-size: 12px;
  font-family: 'IRANYekanXFaNum';
  font-weight: 500;
  text-align: center;
  margin: 20px 0 16px 2px;
  line-height: 15.6px;
`;

export const SLinkContainer = styled(Box)`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 1px;
`;

export const SClickableText = styled.span`
  cursor: pointer;
  color: #60646E;
  font-size: 12px;
  font-family: 'IRANYekanXFaNum';
  font-weight: 500;
  &:hover {
    text-decoration: underline;
  }
`;

export const SDivider = styled.hr`
  width: 100%;
  border: 0.5px solid #ccc;
  margin: 16px 0;
  border: 1px #D9D9DD dotted;
  margin: 2px 0 12px 20px;
`;

export const SsubTitle = styled.h6`
  margin: 2px 0 12px 12px;
  color: #60646E;
  font-size: 14px;
  font-family: 'IRANYekanXFaNum';
  font-weight: 500;
  line-height: 20px;
  text-align: right;
`;

export const STitle = styled.div`
  color: White & Black/10;
  font-size: 20px;
  font-family: 'IRANYekanXFaNum';
  font-weight: 900;
  margin: 2px 0 12px 20px;
  text-align: right;
  line-height: 26px;
`;

export const Sitem = styled.div`
  color: White & Black/10;
  font-size: 14px;
  font-family: 'IRANYekanXFaNum';
  font-weight: 600;
  margin: 2px 0 12px 20px;
  text-align: right;
  line-height: 18.2px;
  align-items: right;
`;

// width: 100% — without it this flex child shrinks to its content and the
// MenuBox grid inside never gets the card's full width.
export const SuBox = styled(Box)({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '16px',
  marginTop: '25px',
});

// Styles for IdentityFormBox
export const ClickableBox = styled(Box)({
  width: '360px',
  height: 'auto',
  padding: '12px 8px', // تغییر به 4px برای فاصله از چپ و راست
  backgroundColor: '#f9f9f9',
  border: '2px dotted #888888',
  borderRadius: '4px',
  display: 'flex',
  flexDirection: 'column',
  cursor: 'pointer',
  transition: 'background-color 0.2s',
  '&:hover': {
    backgroundColor: '#e0e0e0',
  },
  '@media (max-width: 768px)': {
    maxWidth: '310px',
  },
});

export const SecondaryTextA = styled(Typography)({
  fontFamily: 'IRANYekanXFaNum',
  fontSize: 16,
  color: '#FF833D',
  backgroundColor: '#FFE3D3',
  fontWeight: 700,
  lineHeight: 20.8,
  textAlign: 'right',
  paddingRight: 4,
  paddingLeft: 4,
});

export const SecondaryTextB = styled(Typography)({
  fontFamily: 'IRANYekanXFaNum',
  fontSize: 16,
  color: '#1E88E5',
  backgroundColor: '#BBC0CB',
  fontWeight: 700,
  lineHeight: 20.8,
  textAlign: 'right',
  paddingRight: 4,
  paddingLeft: 4,
});

export const TextRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  width: '100%',
  justifyContent: 'flex-end',
  paddingRight: '90px', // Align primary text with SLabel
});

export const SFormContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: calc(100% - 8px); // کم کردن 8px برای فاصله 4px از هر طرف
  gap: 16px;
  margin: 12px 4px 0; // فاصله 4px از چپ و راست
`;

export const SFieldContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
   align-items: baseline;
  gap: 8px; // 8px gap between label and TextField
  direction: rtl;
`;

export const SLabel = styled(Typography)`
  && {
    font-family: 'IRANYekanXFaNum';
    font-size: 14px;
    font-weight: 500;
    text-align: right;
    margin-left: 4px;
    flex: 0 0 auto;
    white-space: nowrap;
    line-height: 1; // این خط را اضافه کنید
    padding-top: 2px; // تنظیم دقیق تراز عمودی
  }
`;

export const SStyledTextField = styled(TextField)`
  && {
    flex: 1;
    max-width: calc(100% - 100px);
    margin-right: 4px;
    
    .MuiOutlinedInput-root {
      width: 100%;
      border-radius: 8px;
      fieldset {
        border-color: #ededed;
      }
      &:hover fieldset {
        border-color: #cfcfcf;
      }
      &.Mui-focused fieldset {
        border-color: #afafaf;
      }
      input {
        padding: 8px 10px; // تغییر padding برای تراز بهتر
        font-size: 12px;
        text-align: right;
        line-height: 1; // این خط را اضافه کنید
      }
    }
    .MuiFormHelperText-root {
      font-size: 10px;
      color: red;
      text-align: right;
      margin-top: 2px;
    }
  }
`;

export const useStyles = makeStyles({
  primaryText: {
    fontFamily: 'IRANYekanXFaNum',
    fontSize: '16px',
    fontWeight: 700,
    color: '#35373C',
    lineHeight: '20.8px',
    textAlign: 'right',
  },
});